import { alertClasses } from '@mui/material/Alert'
import { Theme } from '@mui/material/styles'
export const styles = {
  form: {
    padding: (theme: Theme) => `${theme.spacing(2)} 0`,
    fontSize: '14px',
  },

  formLabel: {
    fontFamily: 'Source Sans Pro Bold',
    marginBottom: (theme: Theme) => theme.spacing(1),
  },

  formSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: (theme: Theme) => `${theme.spacing(1)} ${theme.spacing(2)}`,
  },

  formControl: {
    marginTop: (theme: Theme) => theme.spacing(1),
  },

  formSubSection: {
    backgroundColor: '#f6f6f6',
    margin: (theme: Theme) => `0 ${theme.spacing(-2)}`,
  },

  search: {
    width: '100%',
    padding: (theme: Theme) => `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
  },

  loader: {
    alignItems: 'center',
    marginTop: (theme: Theme) => theme.spacing(5),
  },

  chipList: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  chip: { margin: (theme: Theme) => theme.spacing(0.2) },

  error: {
    color: '#b22222',
    borderColor: '#b22222',
  },

  info: { marginLeft: (theme: Theme) => theme.spacing(0.5) },

  alert: {
    [`& .${alertClasses.icon}`]: {
      paddingTop: (theme: Theme) => theme.spacing(0.8),
    },
    whiteSpace: 'pre-line',
    fontWeight: '400',
    fontSize: '14px',
    width: '100%',
    marginTop: (theme: Theme) => theme.spacing(2),
    marginBottom: (theme: Theme) => theme.spacing(2),
  },

  alertInfo: { display: 'inline' },
}
